import { ILoginReqParams } from '@/core/domain/entities/request';
import { logout, pinCheck, userLogin, checkSession, createAddress } from '@/services/api/UserApi';
import { getStores } from '@/stores';
import { toUser } from '../transfer/toUser';
import { errorCodes } from '@/services/api/errorCodes';
import { showAlertPopup } from './PopupController';
import { replaceNewLineToTag } from '@/utils';

/** 로그인 컨트롤러 */
export async function login(
  loginData: ILoginReqParams,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  const { userStore } = getStores();
  try {
    const res = await userLogin(loginData);

    // 에러 코드(문자열)인 경우
    if ('errorCode' in res) {
      const errorInfo = errorCodes.find((error) => error.code === res.errorCode);
      if (errorInfo) {
        showAlertPopup(
          replaceNewLineToTag(errorInfo.message),
          true,
          false,
          res.errorCount ? res.errorCount.toString() : undefined,
        );
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false }; // 에러 코드는 있지만 매칭되는 메시지가 없는 경우
    }

    userStore.setUser(toUser(res));

    return { succed: true };
  } catch (err) {
    console.error(err);

    return { succed: false };
  }
}

export async function tryPinCheck(
  id: string,
  pin: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const res = await pinCheck({ id, pin });

    // 에러 코드(문자열)인 경우
    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false };
    }

    return { succed: true };
  } catch (error) {
    console.error(error);

    return { succed: false };
  }
}

export async function tryLogout(): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    await logout();

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/** 세션 체크 후 로그인 페이지로 리다이렉트 */
export async function checkSessionAndRedirect(): Promise<boolean> {
  const { userStore } = getStores();
  try {
    const { isLoggedIn, user } = await checkSession();

    if (!isLoggedIn || userStore.isLogout) {
      // 로그인 페이지로 리다이렉트
      window.location.href = '/login';
      return false;
    }

    // 로그인된 상태면 유저 정보 저장
    userStore.setUser(toUser(user));
    return true;
  } catch (err) {
    console.error('Session check failed:', err);
    window.location.href = '/login';
    return false;
  }
}

/** 현재 세션의 유저 정보 조회 */
export async function getSessionUser() {
  const { userStore } = getStores();
  try {
    const { isLoggedIn, user } = await checkSession();

    if (!isLoggedIn || !user) {
      return null;
    }

    // 로그인된 상태면 유저 정보 저장하고 반환
    const userData = toUser(user);
    userStore.setUser(userData);
    return userData;
  } catch (err) {
    console.error('Get session user failed:', err);
    return null;
  }
}

/** 주소 생성 컨트롤러 */
export async function tryCreateAddress(
  id: string,
  phone: string,
): Promise<{
  succed: boolean;
  errorProcceded?: boolean;
  errorMessage?: string;
}> {
  try {
    const res = await createAddress(id, phone);

    // 에러 코드(문자열)인 경우
    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false };
    }

    return { succed: true };
  } catch (error) {
    console.error(error);

    return { succed: false };
  }
}
